import { render, staticRenderFns } from "./DWindingCore.vue?vue&type=template&id=24fb6a6c&scoped=true"
import script from "./DWindingCore.vue?vue&type=script&lang=ts"
export * from "./DWindingCore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fb6a6c",
  null
  
)

export default component.exports